/* eslint-disable @next/next/no-img-element */

import { urlFor } from '../../lib/sanity';
import VideoBlockStyles from '../../styles/elements/VideoBlockStyles.module.scss';
import Link from 'next/link';

const Videothumbblock = ({ Content }) => {
  return (
    <div className={VideoBlockStyles.holder}>
      <div className={VideoBlockStyles.imgclass}>
        <img src={urlFor(Content.image).auto('format').width(600).url()} alt={Content.name} className={VideoBlockStyles.imgclass} width="600" />
      </div>
      <div className={VideoBlockStyles.copy}>
        <h3>{Content.virtualtour}</h3>

        <a href={Content.link} target="_blank" rel="noreferrer">
          <button className={VideoBlockStyles.cta}>{Content.virtualCTA}</button>
        </a>
      </div>
    </div>
  );
};

export default Videothumbblock;
